import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { environment } from './../../environments/environment';
import { BRAND_COLORS } from '../core/brand-colors';

@Component({
  selector: 'app-formulario-dps',
  templateUrl: './formulario-dps.component.html',
  styleUrls: ['./formulario-dps.component.scss']
})

export class FormularioDpsComponent implements OnInit {

  @ViewChild('stepper') stepper!: MatStepper;

  public matricula: string | undefined;
  public showLoader = false;
  public isButtonDisabled: boolean = false;
  public finalizado: boolean = false;


  public dpsForm = new FormGroup({
    questionAnswer1: new FormControl('' , [Validators.required]),
    questionAnswer2: new FormControl('' , [Validators.required]),
    questionAnswer3: new FormControl('' , [Validators.required]),
    questionAnswer4: new FormControl('' , [Validators.required]),
    questionAnswer5: new FormControl('' , [Validators.required]),
    questionAnswer6: new FormControl('' , [Validators.required]),
    questionAnswer7: new FormControl('' , [Validators.required])
  });


  public questionAnswer4List: string[] = [
    'Lúpus Eritematoso Disseminado',
    'Doenças Neurológicas Periféricas ou Esclerose Múltipla',
    'Doença de Parkinson',
    'Derrame (AVC) ou Aneurisma Cerebral',
    'HIV',
    'Doença renal crônica',
    'Cirrose hepática',
    'Transplante de órgãos',
    'Cegueira Legal',
    'Surdez Total',
    'Alzheimer',
    'Nenhum desses',
  ];

  public questionAnswer6List: string[] = [
    'Doença Coronariana',
    'Infarto do Miocárdio',
    'Angioplastia',
    'Revascularização do Miocárdio',
    'Insuficiência Cardíaca',
    'Doença arterial periférica',
    'Doença Pulmonar Crônica',
    'Doença Crônica do aparelho digestivo',
    'Doença Inflamatória Crônica da Coluna',
    'Miastenia Gravis',
    'Leucemias',
    'Dependência química (álcool, drogas ilícitas)',
    'Pancreatite Crônica',
    'Cirurgia De Valva Cardíaca',
    'Doenças Hepáticas Graves',
    'Síndrome de Guilliain Barré',
    'Nenhum desses',
  ];

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    if(this.route.snapshot.queryParams['matricula']) {
      this.matricula = this.route.snapshot.queryParams['matricula'];
    }else{
        this.router.navigate(['/404']);
    }

    this.dpsForm.statusChanges.subscribe(status => {
      this.isButtonDisabled = this.dpsForm.invalid;
    });

    console.log('finalizado', this.finalizado)
  }

  onCheckboxChange(controlName: string, option: string, event: any): void {
    let selectedOptions: string[] = this.dpsForm.get(controlName)?.value?.split(';') || [];

    if (event.checked) {
      if (option === 'Nenhum desses') {
        selectedOptions = ['Nenhum desses'];
      } else {
        const indexNenhumDesses = selectedOptions.indexOf('Nenhum desses');
        if (indexNenhumDesses >= 0) {
          selectedOptions.splice(indexNenhumDesses, 1);
        }
        selectedOptions.push(option);
      }
    } else {
      const index = selectedOptions.indexOf(option);
      if (index >= 0) {
        selectedOptions.splice(index, 1);
      }
    }

    this.dpsForm.get(controlName)?.setValue(selectedOptions.filter(item  => !!item).join(';'));
  }


  formatMultiSelectValue(controlName: string): string {
    const control = this.dpsForm.get(controlName) as FormControl;
    const values = control.value as string[];
    return values.join(';');
  }

  getFormValues() {
    const formValues = this.dpsForm.getRawValue();
    formValues.questionAnswer4 = this.dpsForm.get('questionAnswer4')?.value || '';
    formValues.questionAnswer6 = this.dpsForm.get('questionAnswer6')?.value || '';
    return formValues;
  }

  onStepChange(event: StepperSelectionEvent) {
    // Se o usuário tentar acessar o step "Finalizado!" quando ele não estiver completo, retornamos ao passo anterior
    if (event.selectedIndex === 1 && !this.finalizado) {
      this.stepper.selectedIndex = event.previouslySelectedIndex; // Volta ao step anterior
    }
  }

  onSubmit() {
    if (this.dpsForm.invalid) {
      this.dpsForm.markAllAsTouched();
      Swal.fire({
        icon: 'warning',
        title: 'Todos as perguntas devem ser respondidas.',
        confirmButtonColor: BRAND_COLORS.horizonte700,
      });
      return;
    }

    if (!this.matricula) {
      Swal.fire({
        icon: 'error',
        title: 'Matrícula não encontrada',
        iconColor: BRAND_COLORS.red500,
        confirmButtonColor: BRAND_COLORS.horizonte700,
      });
      return;
    }

    const formValues = this.getFormValues();
    const requestData = {
      ...formValues,
      matricula: this.matricula
    };


    this.showLoader = true;
    this.isButtonDisabled = true;
    this.finalizado = false;

    this.http.post(environment.apiUrl + 'dps', requestData).subscribe(
      response => {
        this.showLoader = false;
        this.isButtonDisabled = true;
        this.finalizado = true;
        this.router.navigate(['/form-submitted']);
      },
      error => {
        Swal.fire({
          icon: 'error',
          title: error?.error?.message,
          text: error?.error?.content,
          iconColor: BRAND_COLORS.red500,
          confirmButtonColor: BRAND_COLORS.horizonte700,
        });
        this.showLoader = false;
        this.isButtonDisabled = false;
        this.finalizado = false;
      }
    );
  }
}
